export const getCalculatedDiscountAmount = (priceDiscountData, quantity, finalItemPrice) => {
    if (priceDiscountData && Object.prototype.hasOwnProperty.call(priceDiscountData, 'discountValue')
      && priceDiscountData.discountValue > 0 ) {
      const {leastQuantity, matchedProdQtyMultiplier, discountType, discountValue} = priceDiscountData;
  
      if (leastQuantity > 0 && quantity < leastQuantity) {
        return 0;
      }
      if (matchedProdQtyMultiplier > 0 && quantity < matchedProdQtyMultiplier) {
        return 0;
      }
  
      if (discountType === 'percentage') {
        const appliedQuantity = matchedProdQtyMultiplier > 0
          ? Math.floor(quantity / matchedProdQtyMultiplier) * matchedProdQtyMultiplier
          : quantity;
        return Math.floor(finalItemPrice * appliedQuantity * (discountValue / 100));
      }
  
      if (discountType === 'amount') {
        const appliedQuantity = matchedProdQtyMultiplier > 0
          ? Math.floor(quantity / matchedProdQtyMultiplier)
          : quantity;
        return discountValue * appliedQuantity;
      }
    }
    return 0;
  }